import { render, staticRenderFns } from "./supply-chain-detail.vue?vue&type=template&id=b5bb9482&scoped=true"
import script from "./supply-chain-detail.vue?vue&type=script&lang=ts"
export * from "./supply-chain-detail.vue?vue&type=script&lang=ts"
import style0 from "./supply-chain-detail.vue?vue&type=style&index=0&id=b5bb9482&prod&scoped=true&lang=scss"
import style1 from "./supply-chain-detail.vue?vue&type=style&index=1&id=b5bb9482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb9482",
  null
  
)

export default component.exports